import { Box, styled } from "@mui/material";
import { EditorContent as TiptapEditorContent } from "@tiptap/react";

import "./tiptap-main.css";
import "./tiptap-toolbar.css";
import "./tiptap-content.css";  // Reusable styles

const TiptapEditorMain = styled(Box)(() => ({
	marginTop: 24,
	marginBottom: 8,
	display: "flex",
	flexDirection: "column",
	height: "200px"
}));

const EditorContent = ({ editor, children }) => {
	return (
		<TiptapEditorMain className="tiptap-editor-main">
			<Box>
				{children}
			</Box>
			<TiptapEditorContent className="tiptap-content-container" editor={editor} />
		</TiptapEditorMain>
	);
};

export default EditorContent;